var exports = {
  "kL": "container__f6BYhC",
  "Sc": "Checkbox__RVKYfn",
  "o_": "CreateIssueFooterContainer__yubysr",
  "Fy": "fileUploadWarningSection__A_Dikp",
  "XX": "warningMessageText__tT6dLH",
  "Ok": "mainContentWrapper__GoH-_s",
  "Pv": "checkboxAndLinksSection__35fcPN",
  "MJ": "FormControl__pT_2d0",
  "rK": "separatorDot__L6ywbB",
  "fc": "actionButtonsContainer__5fsQVU",
  "Fq": "duplicateDetectionShownWrapper__Q8dYzE",
  "u_": "duplicateDetectionEnabledActionsGroup__nLtxCf",
  "$M": "checkboxMarginLeft__ILnno9",
};

module.exports = exports;
